import {RemoteRespondBeneficiaryAddressSuggestionV4} from 'data/usecases';
import {RespondBeneficiaryAddressSuggestionV4} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';

export const makeRespondBeneficiaryAddressSuggestionV4 =
	(): RespondBeneficiaryAddressSuggestionV4 =>
		new RemoteRespondBeneficiaryAddressSuggestionV4(
			makeBFFApiUrl(ProfileChangeDataEndpoints.beneficiaryAddressSuggestionV4),
			makeAuthorizeHttpClientDecorator(),
		);
